import { apiFetch } from './api';
import { ApiError } from './http';
import { readApiError } from './apiError';
import { DeliveryAddress, DeliveryAddressInput } from '../types/api';

export interface AddressApi {
  list(signal?: AbortSignal): Promise<readonly DeliveryAddress[]>;
  create(input: Readonly<DeliveryAddressInput>): Promise<DeliveryAddress>;
  replace(id: string, input: Readonly<DeliveryAddressInput>): Promise<DeliveryAddress>;
  remove(id: string): Promise<void>;
  setDefault(id: string): Promise<DeliveryAddress>;
}
export class AddressApiError extends ApiError {
  constructor(message: string, status: number) {
    super(message, status);
    this.name = 'AddressApiError';
  }
}
export class HttpAddressApi implements AddressApi {
  constructor(private readonly request: typeof apiFetch) {}
  private async send(path: string, init: RequestInit = {}): Promise<Response> {
    const response = await this.request(`/user/addresses${path}`, init);
    if (!response.ok) {
      const message = await readApiError(response, 'Could not update delivery addresses. Please try again.');
      throw new AddressApiError(message, response.status);
    }
    return response;
  }
  async list(signal?: AbortSignal): Promise<readonly DeliveryAddress[]> {
    return (await this.send('', { signal })).json();
  }
  async create(input: Readonly<DeliveryAddressInput>): Promise<DeliveryAddress> {
    return (await this.send('', { method: 'POST', body: JSON.stringify(input) })).json();
  }
  async replace(id: string, input: Readonly<DeliveryAddressInput>): Promise<DeliveryAddress> {
    return (
      await this.send(`/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(input) })
    ).json();
  }
  async remove(id: string): Promise<void> {
    await this.send(`/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
  async setDefault(id: string): Promise<DeliveryAddress> {
    return (await this.send(`/${encodeURIComponent(id)}/default`, { method: 'PUT' })).json();
  }
}
export const addressApi: AddressApi = new HttpAddressApi(apiFetch);
